// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../../services/model/types.tsx';

export const continueToNextTask =
	(): Action<State> =>
	({ getState, setState }) => {
		const { tasks, openTaskId } = getState();
		if (!openTaskId || !tasks) {
			return;
		}

		const openTaskIndex = tasks.items.findIndex((task) => task.id === openTaskId);

		if (openTaskIndex === -1) {
			return;
		}

		// Find the first uncompleted task after the current task
		for (let i = openTaskIndex + 1; i < tasks.items.length; i++) {
			const task = tasks.items[i];
			if (!task.completed) {
				setState({ openTaskId: task.id });
				return;
			}
		}
	};
